<div class="acd-header">
    <div class="acd-header__eyebrow">ACH Payment Authorization</div>
    <div class="acd-header__title">Final Confirmation</div>
</div>

<div class="acd-body">
    <div class="acd-message-block" *ngIf="message">
        <p class="acd-message-block__main">{{ message }}</p>
    </div>

    <div class="acd-content">
        <div *ngIf="message2" class="acd-sub-message">{{ message2 }}</div>

        <div class="acd-agree-row">
            <dx-form [formData]="model" validationGroup="mainValidationGroup" [colCount]="1">
                <dxi-item dataField="agreed" editorType="dxCheckBox" [label]="{ text: 'I Agree' }">
                    <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
                </dxi-item>
            </dx-form>
        </div>

        <div *ngIf="feeMessage" class="acd-fee-message">
            <i class="fa fa-info-circle me-2"></i>{{ feeMessage }}
        </div>
    </div>
</div>

<div class="acd-footer">
    <button class="acd-btn acd-btn--approve" [disabled]="!model.agreed || processing" (click)="save()">
        <i class="fa fa-check me-2"></i>Submit
    </button>
    <button class="acd-btn acd-btn--ghost" [disabled]="processing" (click)="cancel()">Cancel</button>
</div>
